import store from '@/store'
import * as Lockr from 'lockr'
import axios from 'axios'

const cache = {
  /**
   * 載入全部登陸資訊
   */
  loadingCache: function() {
    if (Lockr.get('authKey') && !axios.defaults.headers.authKey) {
      /** 將使用者資訊放入快取 */
      const userInfo = Lockr.get('loginUserInfo')
      if (userInfo) {
        store.commit('SET_USERINFO', userInfo)
      }
    }
    store.commit('SET_APPNAME', Lockr.get('systemName'))
    store.commit('SET_APPLOGO', Lockr.get('systemLogo'))
    store.dispatch('SystemLogoAndName')
  },
  /**
   * 請求和更新登錄快取
   */
  updateAxiosCache: function() {
    axios.defaults.headers.authKey = Lockr.get('authKey')
    axios.defaults.headers.sessionId = Lockr.get('sessionId')
    store.dispatch('GetUserInfo')
  },
  /**
   * 移除登錄資訊
   * @param {*}
   */
  rmAxiosCache: function() {
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
  }
}

export default cache
